import { useEmployeeScopedQuery } from "@/features/purchasePoints/hooks/useEmployeeScopedQuery";
import { purchasePointsService } from "@/features/purchasePoints/services/purchasePoints.service";
import type { PurchasePointsRewardsResponse } from "@/features/purchasePoints/types/purchasePointsReward.type";

export const usePurchasePointsRewards = (page: number, perPage: number) => {
  const {
    data, isLoading, isDisabled, isFetching, error, retry,
  } = useEmployeeScopedQuery<PurchasePointsRewardsResponse>({
    scope: "purchasePointsRewards",
    key: [page, perPage],
    queryFn: () => purchasePointsService.getRewards(page, perPage),
  });

  return {
    rewards: data?.rewards ?? [],
    metadata: data?.metadata,
    isLoading,
    isDisabled,
    isFetching,
    error,
    retry,
  };
};
